import axios from 'axios'

export default {
  namespaced: true,
  state: {
    courses: [],
    loading: false
  },
  mutations: {
    loading(state, value) {
      state.loading = value
    },
    courses(state, value) {
      state.courses = value
    }
  },
  actions: {
    fetchClassroomCourses({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('loading', true)
        // axios.get('/lesson')
        axios.get('/subjects')
          .then((response) => {
            commit('courses', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            commit('loading', false)
          })
      })
    },
    fetchCourse({commit, state}, id) {
      return axios.get('/lesson/' + id)
        .then(({data}) => {
          return Promise.resolve(data)
        })

    }
  },
  getters: {
    courses: state => state.courses,
    loading: state => state.loading
  }
}
